module.exports = __webpack_public_path__ + "static/media/person.c48f8284.png";